import toastReducer from '../connected-components/toast/reducer';
import loadingReducer from '../connected-components/loading/reducer';
import uploadModalReducer from '../connected-components/uploadModal/reducer';
import questionModalReducer from '../connected-components/questionModal/reducer';

import specialityModalReducer from '../connected-components/specialityModal/reducer';
import settingsModalReducer from '../connected-components/settingsModal/reducer';
import chooseSpecialtyModalReducer from '../connected-components/chooseSpecialtyModal/reducer';
import filtersModalReducer from '../connected-components/filtersModal/reducer';
import dateRangePickerModalReducer from '../connected-components/dateRangePickerModal/reducer';
import languageReducer from '../screens/content/languages/reducer';
import authReducer from '../screens/auth/login/reducer';
import onboardingReducer from '../screens/auth/onboarding/reducer';
import settingsReducer from '../screens/content/settings/reducer';
import languagePickerModalReducer from '../connected-components/languagePickerModal/reducer';
import countryPickerModalReducer from '../connected-components/countryPickerModal/reducer';
import homeTabsReducer from '../screens/content/home/reducer';
import chatReducer from '../screens/content/chat/reducer';
import clinicalCaseReducer from '../screens/content/clinicalCase/reducer';

/**
 * Represents the root reducer for the application.
 * @type {Object}
 */
export default {
  toast: toastReducer,
  loading: loadingReducer,
  uploadModal: uploadModalReducer,
  questionModal: questionModalReducer,

  lang: languageReducer,
  auth: authReducer,
  onboarding: onboardingReducer,
  specialityModal: specialityModalReducer,
  settingsModal: settingsModalReducer,
  settings: settingsReducer,
  filtersModal: filtersModalReducer,
  chooseSpecialtyModal: chooseSpecialtyModalReducer,
  dateRangePickerModal: dateRangePickerModalReducer,
  languagePickerModal: languagePickerModalReducer,
  countryPickerModal: countryPickerModalReducer,
  homeTabs: homeTabsReducer,
  chat: chatReducer,
  clinicalCase: clinicalCaseReducer,
};
